<template>
    <div
        v-if="!grouperCollapsed"
        v-bind:class="wrapperClassObject"
        class="d-flex px-1 border align-items-center">
        <!-- allow interaction with buttons without dragging -->
        <div
            no-interact
            class="d-flex align-items-center ms-2">
            <div
                v-if="item.showIndent"
                class="invisible p-1">
                <!-- guarantee width of no-interact is equal for grouper and child -->
                <pc-bs-icon name="chevron-down" />
            </div>
            <div
                v-if="!dragOnly"
                class="my-2">
                <pc-checkbox
                    v-bind:key="internalKey"
                    v-bind:model-value="selected"
                    v-bind:readonly="disableCheckbox"
                    v-bind:use-indeterminate="Boolean(item.grouper)"
                    v-on:update:model-value="onInput" />
            </div>
            <div
                v-if="item.grouper"
                class="p-1 grouper-collapsible"
                v-on:click="$emit('toggle-grouper')">
                <pc-bs-icon
                    name="chevron-right"
                    v-bind:rotate-on="!collapsed" />
            </div>
        </div>
        <div
            ref="itemLabelWrapper"
            class="w-100 text-break"
            v-bind:style="itemStyle">
            <slot v-bind:item="item">
                <div class="py-2 me-2">
                    <span>{{ item.label }}</span>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
    import { eventIsInsideRect } from "Components/orderable/_util.js";

    export default {
        props: {
            item: { type: Object, required: true },

            // the selected prop must accept null values, so it can't be required
            selected: { type: Boolean, required: false, default: false },
            collapsed: { type: Boolean, required: false, default: false },
            grouperCollapsed: { type: Boolean, required: false, default: false },

            dragged: { type: Boolean, required: false, default: false },
            dragOnly: { type: Boolean, required: false, default: false },
            disabled: { type: Boolean, required: false, default: false },
            readonly: { type: Boolean, required: false, default: false }
        },
        emits: ["toggle-grouper", "item-selected"],
        data() {
            return {
                internalKey: 1
            };
        },
        computed: {
            wrapperClassObject() {
                return {
                    "top-level-wrapper": !this.item.showIndent,
                    "indented-wrapper": this.item.showIndent,
                    "select-disabled": this.dragOnly && this.selected,
                    "bg-light": !(this.dragOnly && this.selected)
                };
            },
            itemStyle() {
                if (!this.selected && !this.disabled && !this.readonly) {
                    return {
                        cursor: this.dragged ? "grabbing" : "grab"
                    };
                }
                return {};
            },
            disableCheckbox() {
                return (this.disabled && !this.selected) || this.readonly;
            }
        },
        methods: {
            isInside(dragEvent) {
                // called by parent (pc-categorized-filter) when dragging
                if (!this.$refs.itemLabelWrapper) {
                    return false;
                }
                const rect = this.$refs.itemLabelWrapper.getBoundingClientRect();
                return eventIsInsideRect(rect, dragEvent);
            },
            onInput(selected) {
                this.$emit("item-selected", { selected, itemComponent: this });
            },
            reRender() {
                this.internalKey++;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .select-disabled {
        background-color: #cccccc;
    }

    .grouper-collapsible {
        cursor: pointer;
    }

    .top-level-wrapper {
        position: relative;
        z-index: 2;
    }

    .indented-wrapper {
        position: relative;
        z-index: 1;
    }
</style>
